const questionBankManagement = () => import('./questionBankManagement');
const addQuestion = () => import('./addQuestion');
const enterQuestion = () => import('./enterQuestion');
const questionLabel = () => import('./questionLabel');
const questionList = () => import('./questionList');

const Router = [
  {
    path: 'questionBankManagement',
    name: 'questionBankManagement',
    component: questionBankManagement,
    meta: {
      title: '题库管理',
    },
  },
  {
    path: 'questionLabel',
    name: 'questionLabel',
    component: questionLabel,
    meta: {
      title: '标签管理',
    },
  },
  {
    path: 'questionList',
    name: 'questionList',
    component: questionList,
    meta: {
      title: '题目列表',
    },
  },
  {
    path: 'addQuestion',
    name: 'addQuestion',
    component: addQuestion,
    meta: {
      title: '录入题库',
    },
  },
  {
    path: 'enterQuestion',
    name: 'enterQuestion',
    component: enterQuestion,
    meta: {
      title: '批量录入题库',
    },
  },
];
export default Router;
